"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParsedTextFromOas = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const ParsedTextFromOas = ({ markup }) => {
    return markup?.length > 0 ? (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: markup } })) : (react_1.default.createElement(react_bootstrap_1.Placeholder, null,
        react_1.default.createElement(react_bootstrap_1.Placeholder, { xs: 1, animation: 'glow' })));
};
exports.ParsedTextFromOas = ParsedTextFromOas;
